import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ed3b3c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ml10 p20"
};
const _hoisted_2 = {
  class: "account"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "account_label"
}, "账户钱包余额", -1));
const _hoisted_4 = {
  class: "account_price"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "account_price_unit"
}, "元", -1));
const _hoisted_6 = {
  class: "mt15 info"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info_label"
}, "充值账户信息", -1));
const _hoisted_8 = {
  class: "mt10"
};
const _hoisted_9 = {
  class: "info_text mt10"
};
const _hoisted_10 = {
  class: "info_text mt10"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "info_desc mt35"
}, [/*#__PURE__*/_createTextVNode(" 注：充值时请务必使用当前合作企业的对公账户进行充值打款。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("贵司完成充值转账后金额未及时到账可联系客服咨询； ")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("p", _hoisted_4, [_createTextVNode(_toDisplayString($setup.data.amount), 1), _hoisted_5])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [$setup.data.bankList[0].isDefault ? (_openBlock(), _createBlock(_component_el_tag, {
    key: 0,
    class: "mr5",
    effect: "plain"
  }, {
    default: _withCtx(() => [_createTextVNode("默认")]),
    _: 1
  })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($setup.data.bankList[0].companyName), 1)]), _createElementVNode("p", _hoisted_9, "账 户： " + _toDisplayString($setup.data.bankList[0].bankAccount), 1), _createElementVNode("p", _hoisted_10, " 开 户 行： " + _toDisplayString($setup.data.bankList[0].openBankName), 1), _hoisted_11])]);
}